export const blockForm = {
    create : {title : "Build a new Block", send : "Create"},
    update : {title : "Update your Block",  send : "Update"}
}

export const variableForm = {
    create : {title : "Add a new variable", send : "Add"},
    update : {title : "Edit variable",  send : "Update"}
}